import { render } from "./pivotedit.vue?vue&type=template&id=01f48883"
import script from "./pivotedit.vue?vue&type=script&lang=js"
export * from "./pivotedit.vue?vue&type=script&lang=js"

import "./pivotedit.vue?vue&type=style&index=0&id=01f48883&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__